import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useModal } from '../../utils/modal';

import api from '../../utils/api';
import config from '../../config';
import CardModal from '../stripe/CardModal';

import { fetchUserData, confimStripeCard } from '../../store/actions/account';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

function CreditCard() {
  const modal = useModal();
  const { t } = useTranslation(['account']);
  const [setupIntent, setSetupIntent] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const tenant = useSelector(state => state.tenant);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const init = async () => {
      const hasKey = !!localStorage.getItem('stripePublicKey');
      const token = localStorage.getItem(config.auth.accessTokenKey);
      const tokenType = localStorage.getItem('token_type');

      if (
        !hasKey &&
        tenant &&
        tenant.usePayments &&
        token &&
        tokenType === 'member'
      ) {
        const { stripe_key } = await api.stripe.getKey();
        localStorage.setItem('stripePublicKey', stripe_key.public);
      }

      const key = localStorage.getItem('stripePublicKey');
      if (key) {
        setStripePromise(loadStripe(key));
        openIntent();
      }
    };

    init();
  }, [tenant]);

  const openIntent = async () => {
    try {
      const response = await api.user.createStripeSetupIntents();
      setSetupIntent(response.stripe_setup_intent);
    } catch (error) {
      throw error;
    }
  };

  const confirmCard = async confirmMethod => {
    try {
      const response = await dispatch(
        confimStripeCard(setupIntent.id, confirmMethod.payment_method, false)
      );
      enqueueSnackbar(t('payment_method:add-payment-methods-success'), {
        variant: 'success'
      });
      await dispatch(fetchUserData());
    } catch (error) {
      throw error;
    }
  };

  const onResult = result => {
    if (result.error && result.error.message) {
      enqueueSnackbar(result.error.message, { variant: 'error' });
    } else if (result && result.setupIntent) {
      confirmCard(result.setupIntent);
    } else {
      enqueueSnackbar('error', { variant: 'error' });
    }
  };

  return (
    <div>
      <Elements stripe={stripePromise}>
        <CardModal
          isModal={false}
          isMobile={isMobile}
          setupIntent={setupIntent}
          open={modal.isOpen}
          onClose={modal.close}
          onResult={onResult}
        />
      </Elements>
    </div>
  );
}

export default CreditCard;
